/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Status_DeprovisioningInputs */



/**
* | output |
* | --- |
* | "Winding down" |
*
* @param {Dashboard_Status_DeprovisioningInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const dashboard_status_deprovisioning = /** @type {((inputs?: Dashboard_Status_DeprovisioningInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Status_DeprovisioningInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отключается")
	return /** @type {LocalizedString} */ ("Winding down")
});